import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DevicesAppWebComponentSchema } from '../types';

export class DevicesAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<DevicesAppWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
